function checkTier() {
  let cantidad = 0;

  fetch('/cart.js')
  .then(response => response.json())
  .then(cart => {
    let products_in_cart = cart.items
      .filter(item => item.line_price > 0)
      .reduce((total, item) => total + item.quantity, 0);

    let tier_message = "";

    // Get tier blocks from section
    const tierBlocks = window.tierBlocks || [];
    
    for (const block of tierBlocks) {
      if (products_in_cart === block.tier) {
        tier_message = block.title;
      }
    }

    if (tierBlocks.length > 0) {
      const allTiers = tierBlocks.map(block => block.tier);
      if (!allTiers.includes(products_in_cart)) {
        tier_message = "<strong>¡Brilla como nunca!</strong> Completa tu compra y luce espectacular";
      }
    }

    const tierMainElement = document.querySelector(".product-tier");
    const tierLabelElement = document.querySelector(".product-tier__label");

    if (tier_message) {
      if (tierLabelElement && tierMainElement) {
        tierLabelElement.innerHTML = tier_message;
        tierMainElement.classList.add("active");
      } else {
        tierMainElement.classList.remove("active");
      }
    } else {
      tierMainElement.classList.remove("active");
    }
  })
  .catch(error => console.error("Error al obtener el carrito:", error));
}

document.addEventListener("DOMContentLoaded", function() {
  checkTier();
}); 